import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import awardService from "../../services/award/awardService";
import UploadModules from "../../constants/uploadModules";

import "./Award.css";

export default function AwardForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        awardTitle: "",
        awardDescription: "",
        awardDate: "",
        awardImage: "",
        displayOrder: 0,
        isActive: true
    });

    useEffect(() => {

        if (isEdit) {

            loadAward();

        }

    }, []);

    const loadAward = async () => {

        try {

            setLoading(true);

            const response = await awardService.getById(id);
            const data = response.data;

            if (response.success) {

                const data = response.data;

                setForm({
                    awardTitle: data.awardTitle || "",
                    awardDescription: data.awardDescription || "",
                    awardDate: data.awardDate
                        ? data.awardDate.substring(0, 10)
                        : "",
                    awardImage: data.awardImage || "",
                    displayOrder: data.displayOrder || 0,
                    isActive: data.isActive
                });

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.awardTitle.trim()) {
            toast.error("Award Title is required.");
            return;
        }

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await awardService.update(id, form);
            }
            else {

                response = await awardService.create(form);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/awards")

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit Award" : "Add Award"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">


                            <div className="col-lg-6">

                                <label className="form-label">
                                    Award Title <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="awardTitle"
                                    value={form.awardTitle}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Award Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="awardDate"
                                    value={form.awardDate}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Display Order */}
                            <div className="col-lg-3">

                                <label className="form-label">
                                    Display Order
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>
                            <div className="col-lg-12">

                                <label className="form-label">
                                    Award Description
                                </label>

                                <textarea
                                    rows="5"
                                    className="form-control"
                                    name="awardDescription"
                                    value={form.awardDescription}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Image */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Award Image
                                </label>

                                <ImageUploader
                                    module={UploadModules.AWARD}
                                    value={form.awardImage}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            awardImage: path
                                        })
                                    }
                                />

                            </div>


                            {/* Status */}
                            <div className="col-lg-2 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/awards")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}